interface Props {
  style?: any;
}

export const Logo2 = (props: Props) => {
  return <img src="/logo.png" style={{ ...props.style, width: 183 }} alt="" />;
};
